import axios from 'axios'

export default {
    namespaced: true,
    state: {
        hotel: [],
        tasks: [],
        hotelStaffs: [],
        workTypes: [],
        addWorks: [],
        works: [],
        revisionPoints: [],
    },
    mutations: {
        CHANGE_HOTEL(state, payload) {
            state.hotel = payload
        },
        FETCH_TASKS(state, payload) {
            state.tasks = payload
        },
        FETCH_STAFFS(state, payload) {
            state.hotelStaffs = payload
        },
        FETCH_WORKS(state, payload) {
            state.works = payload
        },
        FETCH_WORK_TYPES(state, payload) {
            state.workTypes = payload
        },
        FETCH_ADD_WORKS(state, payload) {
            state.addWorks = payload
        },
        FETCH_R_P(state, payload) {
            state.revisionPoints = payload
        },
        ADD_TASK(state, payload) {
            state.tasks.push(payload)
        },
        EDIT_TASK(state, payload) {
            const index = state.tasks.findIndex(
                item => item.id === payload[0].id
            )

            if (index !== -1) {
                Object.assign(state.tasks[index], payload[0])
            }
        },
        CHANGE_TASK_STATUS(state, payload) {
            const index = state.tasks.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                state.tasks[index].status = payload.status
            }
        },
        DEL_TASK(state, id) {
            const index = state.tasks.findIndex(
                list => list.id === id
            )
            state.tasks.splice(index,1)
        },
        CLEAR_DATA(state, payload) {
            if (payload > 1) {
                state.hotelBuilds = []
            }
                state.hotelFloors = [],
                state.hotelRooms = [],
                state.hotelStaffs = [],
                state.workTypes = []
        }
    },
    actions: {
        getHotelData({commit, dispatch, state}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/hotel/item',
                    {params: filter}
                ).then(({data}) => {
                    commit('CHANGE_HOTEL', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetch({commit, dispatch, state}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/tasks/list',
                    {params: filter}
                ).then(({data}) => {
                    commit('FETCH_TASKS', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetchStaffs({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/staffs/list',
                    {params: filter}
                ).then(({data}) => {
                    commit('FETCH_STAFFS', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        attachMaid ({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/maid/' + payload.id,
                    payload
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/task/edit/' + payload.id,
                    { ...payload, id: undefined } // убрать id из тела
                ).then(({data}) => {
                    if (!data) {
                        const msg = 'Произошла ошибка. Попробуйте отправить данные еще раз'
                        dispatch('showSystemMessage', {text: msg}, {root: true})
                    }

                    commit("EDIT_TASK", data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetchWorkTypes({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/work-types/list',
                    {params: filter}
                ).then(({data}) => {
                    commit('FETCH_WORK_TYPES', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetchAddWorks({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/add-works/list',
                    {params: filter}
                ).then(({data}) => {
                    commit('FETCH_ADD_WORKS', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        addComment({commit, dispatch}, comment) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/comments/add',
                    comment
                ).then(({data}) => {
                    commit('EDIT_TASK', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        addAuditor({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/auditor/' + payload.id,
                    payload
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        editAuditor({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/change/' + payload.id,
                    payload
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        add({commit, dispatch}, data) {
            data.room_id = data.room.id
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/tasks/add',
                    data
                ).then(() => { resolve() }
                ).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        close({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/close/' + data.id,
                    data
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/mixins/tasks/dell/' + itemId
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },

        /**
         * Выбирает базовые чек-листы
         * @returns {Promise<Object>} promise с базовыми чек-листами
         */
        getBaseCheckLists({dispatch}) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/check-lists/list',
                ).then(({data}) => {
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        acceptRevPoint({dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/revision-point/' + payload.id,
                    payload
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        revision({commit, dispatch}, payload) {
            // изменить статус
            // получить сохраненные пункты на доработку
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/tasks/revision/' + payload.id,
                    payload
                ).then(({data}) => {
                    if (!data) {
                        const msg = 'Произошла ошибка. Попробуйте отправить данные еще раз'
                        dispatch('showSystemMessage', {text: msg}, {root: true})
                    }
                    else {
                        commit(
                            'CHANGE_TASK_STATUS',
                            {
                                status: payload.status,
                                return_count: payload.return_count,
                                id: payload.id,
                                total_score:payload.total_score
                            }
                        )
                    }
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        revisionPoints({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/tasks/revision-points',
                    {params: filter}
                ).then(({data}) => {
                    commit('FETCH_R_P', data.data)
                    resolve()
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        getRevisionList({dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/check-lists/revision',
                    {params: filter}
                ).then(({data}) => {
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        clearData({commit}, quantity) {
            commit('CLEAR_DATA', quantity)
        }
    }
}
